<template>
	<div class="fill-input position-rel">
		<b v-if="dataSource.code">{{ dataSource.code }} </b>
		<div class="fill-input__img" v-if="dataSource.content">
			<img :src="`${urlQuestionImg}/${dataSource.content}`" :alt="dataSource.content">
		</div>
		<input 
			type="text" 
			class="form-control input-hide-place"
			:id="`fill_img_${location}`"
			:value="dataSource.answerContent"
			:ref="`fill_img_${location}`"
			@blur="changeAnswer($event, {location, type: parent.type, questionId: dataSource.questionId})"
			@focus="handleFocus($event, {location, type: parent.type, questionId: dataSource.questionId})"
			@change="changeAnswer($event, {location, type: parent.type, questionId: dataSource.questionId})" 
			@keyup="handleFocus($event, {location, type: parent.type, questionId: dataSource.questionId})"
			placeholder="?"
      autocomplete="off"
		>
			<!-- v-model="dataSource.answerContent"  -->
			<!-- :value="dataSource.answerContent"  -->
	</div>
</template>

<script>
	import mixinsQuestionPreview from './../../_store/mixinsQuestionPreview'
	import { APP_CONFIG } from '@/utils/constants'
	import { STORE_KEY } from './../../_store/constants'
	import { mapState, mapActions } from 'vuex'

	export default {
		name: 'FillInputImg',
		mixins: [ mixinsQuestionPreview ],
		data () {
			return {
				focusId: null,
				urlQuestionImg: APP_CONFIG.urlQuestionImg
			}
		},
		computed: {
			...mapState(STORE_KEY, ['valVituralKeyboard'])
		},
		methods: {
			...mapActions(STORE_KEY, ['setVituralKeyVal']),

			handleFocus(evt, info = {}) {
				let halfWindowHeight = window.innerHeight/2;
				let offsetTopElm = this.$refs[`fill_img_${info.location}`].getBoundingClientRect().top;
        let offsetLeftElm = this.$refs[`fill_img_${info.location}`].getBoundingClientRect().left;

        let spaceHeightInput = (offsetTopElm/window.innerHeight)*100 > 80 ? 20 : 50  // 50 or 20 is height input

				// Obj have ref key support render value onpress vitural keyboard
				this.setVituralKeyVal({
					...info,
					val: evt.target.value,
					isOverHaflScreen: offsetTopElm > halfWindowHeight ? true : false,
					ref: `fill_img_${info.location}`,
          top: offsetTopElm + spaceHeightInput,
          left: offsetLeftElm/2 // /2 is box center
				})
			},

			handleBlur(evt) {
				this.setVituralKeyVal({
					...this.valVituralKeyboard,
					val: evt.target.value
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
</style>